module.exports = __webpack_public_path__ + "static/media/dr-ai-report.cf11ae5a.svg";